/* eslint-disable no-useless-constructor */
import networkList from '../constants/networkList';
import axios from 'axios';
import {Modal} from 'antd';
import Storage from './local-store';

const {base_url} = networkList;

const HttpClient = axios.create({
    baseURL: base_url,
    headers: {
        'Content-Type': 'application/json',
        "accept": "application/json"
    }
});
function userTrackService(data){
    let obj = {"data": data}
    return _userTrackService('logUserActivity', 'POST', obj);
}
function _userTrackService(url, method, data) {
    const token = JSON.parse(Storage.get('token'));
    return HttpClient({
            method: method,
            url: url,
            data: data,
            headers: {
                'authorization': token
            }
        }).then(function (response) {
        const {data} = response;
        const {status} = response;
        if (status === 200) {
            if (data.status) {
                return data;
            } else {
                // Modal.error({title: data.message});
                return data;
            }
        } else {
                // Modal.error({title: data.message});
                return false;
            }
        })
        .catch(function (error) {
            //Modal.error({zIndex:1600,title: error.message});
            return false;
        });
}
export default userTrackService;